import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Box, alpha, useTheme } from '@mui/material';
import { paths } from '@/routes/paths';
import { CreateSocialAdSurface } from '@/components/social-ads/CreateSocialAdSurface';

// /dashboard/social-ads/create — single unified creation surface. Mirrors the
// /dashboard/emails/create flow: prompt input + collapsible attach panels
// (Template / Products / Media / Size) + streaming progress. Route is just
// chrome — CreateSocialAdSurface owns the whole flow.

interface CreateSocialAdSearch {
  prompt?: string;
}

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/social-ads/create')({
  component: CreateSocialAdPage,
  validateSearch: (search: Record<string, unknown>): CreateSocialAdSearch => ({
    prompt: typeof search.prompt === 'string' ? search.prompt : undefined,
  }),
});

function CreateSocialAdPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const search = Route.useSearch();
  const { orgId, clientId } = Route.useParams();
  const tp = paths.dashboard.tenant(orgId, clientId);

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: `linear-gradient(145deg, ${theme.palette.grey[50]} 0%, ${alpha(theme.palette.primary.light, 0.12)} 50%, ${theme.palette.grey[100]} 100%)`,
        px: { xs: 2, md: 3 },
        py: { xs: 1, md: 2 },
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          width: '100%',
          mx: 'auto',
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CreateSocialAdSurface
          onBack={() => navigate({ to: tp.socialAds })}
          initialPrompt={search.prompt}
        />
      </Box>
    </Box>
  );
}
